import { Flowbite, ThemeModeScript } from 'flowbite-react';
import { ToastContainer } from 'react-toastify';
import { AppProvider } from "./layouts/App-Context";
import AppRoutes from "./routes/Router";
import customTheme from './utils/theme/custom-theme';


function App() {

  return (
    <>
    <AppProvider>
      <ThemeModeScript />
      <Flowbite theme={{ theme: customTheme}}>
      <ToastContainer />
         {/* <ErrorBoundary fallback={<Error/>}> */}
         <AppRoutes/>
         {/* </ErrorBoundary> */}
      

      </Flowbite>
      </AppProvider>
    </>
  );
}

export default App;
